import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'accounting_software/api/'

export default {
  namespaced: true,
  state: {
    search: '',
    pagination: {
      rowsPerPage: 10,
      sortBy: null,
      totalItems: 0,
      page: 1
    },
    list: { 'results': [] },
    // typeDocument: [],
    // listPayer: { 'results': [] },
    card: {
      id: null,
      software_name: '',
      price: null,
      quantity: null,
      install_loc: '',
      responsible: '',
      inventory_year: null,
      document: null,
      date_end: null,
      reason_end: ''
    },
    defaultCard: {
      id: 'new',
      software_name: '',
      price: null,
      quantity: null,
      install_loc: '',
      responsible: '',
      inventory_year: null,
      document: null,
      date_end: null,
      reason_end: ''
    }
  },
  mutations: {
    setSearch (state, payload) {
      state.search = payload
    },
    setList (state, payload) {
      state.list = payload
    },
    setCard (state, payload) {
      state.card = payload
    },
    createCard (state) {
      state.card = Object.assign({}, state.defaultCard)
    },
    setCardDocument (state, payload) {
      state.card.document = payload
    }
  },
  actions: {
    fetchList ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'ASDocumentFetchForcedList'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'software/'
        let params = {}
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        if (payload.search > '') {
          params['search'] = payload.search
        }

        session.get(_url, { params: params })
          .then(response => {
            commit('setList', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchCard ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'ASDocumentFetchCard'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        // commit('setDefaultForcedAcknowledgement', payload)
        let _url = appURL + 'software/' + payload + '/'
        session.get(_url)
          .then(response => {
            commit('setCard', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertCard ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'ADInsertCard_' + payload.charge
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        const data = new FormData()
        data.append('software_name', payload.software_name)
        data.append('price', payload.price)
        data.append('quantity', payload.quantity)
        if (payload.install_loc) {
          data.append('install_loc', payload.install_loc)
        } else {
          data.append('install_loc', '')
        }
        if (payload.responsible) {
          data.append('responsible', payload.responsible)
        } else {
          data.append('responsible', '')
        }
        if (payload.inventory_year) {
          data.append('inventory_year', payload.inventory_year)
        } else {
          data.append('inventory_year', '')
        }
        if (payload.document) {
          data.append('document', payload.document)
        } else {
          data.append('document', '')
        }
        if (payload.date_end) {
          data.append('date_end', payload.date_end)
        } else {
          data.append('date_end', '')
        }
        if (payload.reason_end) {
          data.append('reason_end', payload.reason_end)
        } else {
          data.append('reason_end', '')
        }
        let _url, method
        if (payload.id === 'new') {
          _url = appURL + 'software/'
          method = 'post'
        } else {
          _url = appURL + 'software/' + payload.id + '/'
          method = 'put'
        }
        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('setCard', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteCard ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'ASDeleteCard_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'software/' + payload + '/delete/'
        session.get(_url)
          .then(response => {
            commit('createCard')
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    search (state) {
      return state.search
    },
    pagination (state) {
      return state.pagination
    },
    list (state) {
      return state.list
    },
    card (state) {
      return state.card
    },
    defaultCard (state) {
      return state.defaultCard
    }
  }
}
